import styled from 'styled-components';
export const GhostButton = styled.button.withConfig({
  displayName: "GhostButton",
  componentId: "sc-1rgunok-0"
})(["padding:0;appearance:none;border:none;background-color:transparent;user-select:none;&:focus{outline:none;}"]);